// Per-tab cap on client error reporting. One stuck client must not flood
// site_events: a crash-looping component once wrote ~4,900 rows from a single
// visitor, and a chunk-load retry loop wrote 362 in 18 minutes. The first few
// occurrences carry all the diagnostic signal, so everything past the cap is
// dropped client-side (module state = per tab lifetime, deliberately not
// reset on SPA navigation — a broken session stays capped).

const PER_MESSAGE_CAP = 5
const TOTAL_CAP = 20

// Outlook SafeLinks / Defender link-scanner artifact: its sandboxed Chromium's
// injected CefSharp binding rejects with exactly this shape. No real code
// produces it, and each mailing's scan wave used to land ~1,800 rows across
// ten Id:N gids (2026-07-24), so it's dropped at capture entirely.
const SCANNER_NOISE = /^Object Not Found Matching Id:\d+, MethodName:/

const perMessage = new Map<string, number>()
let total = 0

export const shouldReportError = (message: string): boolean => {
  if (SCANNER_NOISE.test(message)) {
    return false
  }
  if (total >= TOTAL_CAP) {
    return false
  }
  const seen = perMessage.get(message) ?? 0
  if (seen >= PER_MESSAGE_CAP) {
    return false
  }
  perMessage.set(message, seen + 1)
  total += 1
  return true
}
